<!-- eslint-disable vue/multi-word-component-names -- Existing component, kept for backward compatibility -->
<template>
    <div class="text-center leading-tight">
        <div ref="headingRef" tabindex="-1" class="max-w-xl title outline-none">
            <template v-if="hrisData">
                <span class="gradient-text">Here's what I know about you</span>
                <p class="text-valence-grey-750 text-center title-subsection mt-3">Feel free to adjust your name and role</p>
            </template>
            <template v-else>
                <span class="gradient-text">Meet Nadia,</span>
                <br />your new personalized coach and thought partner
                <p class="text-valence-grey-750 text-center title-subsection mt-3">Nadia will begin to personalize based on your name and role</p>
            </template>
        </div>
    </div>

    <form class="flex flex-col gap-10 md:gap-15 items-center w-full max-w-xl mt-6" @submit.prevent="onSubmit">
        <HrisProfileCard v-if="hrisData" v-model:name="userName" v-model:role="userRole" :hris-data="hrisData" />

        <!-- Standard inputs when no HRIS data -->
        <div v-else class="flex flex-col gap-2 w-full justify-center">
            <div class="form-control">
                <input id="name" v-model="userName" aria-label="Name" required type="text" class="form-control-input p-6" placeholder="Name" />
                <div v-if="formFieldHasError('name')" class="body-small text-red-700">{{ errors.name }}</div>
            </div>
            <div class="form-control">
                <input id="role" v-model="userRole" aria-label="Role" required type="text" class="form-control-input" placeholder="Role" />
                <div v-if="formFieldHasError('job_title')" class="body-small text-red-700">{{ errors.job_title }}</div>
            </div>
        </div>

        <BaseButton theme="primary" class="w-75 leading-6 body-small" type="submit" data-testid="submit" :disabled="!userName.trim() || !userRole.trim()"> Next </BaseButton>
    </form>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import { onMounted, ref } from "vue";

import HrisProfileCard from "./HrisProfileCard.vue";

const props = defineProps({
    errors: Object,
    hrisData: Object,
});

const emit = defineEmits(["submit"]);
const headingRef = ref(null);
const userName = ref("");
const userRole = ref("");

onMounted(() => {
    if (props.hrisData) {
        const first = props.hrisData.first_name || "";
        const last = props.hrisData.last_name || "";
        const fullName = [first, last].filter(Boolean).join(" ");
        if (fullName) {
            userName.value = fullName;
        }
        if (props.hrisData.job_title) {
            userRole.value = props.hrisData.job_title;
        }
    }
    headingRef.value?.focus();
});

function formFieldHasError(field) {
    return props.errors && Object.hasOwn(props.errors, field);
}

function onSubmit() {
    emit("submit", {
        name: userName.value,
        job_title: userRole.value,
    });
}
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.form-control {
    @apply flex flex-col gap-1;
}

.form-control-input {
    @apply w-full p-6 leading-none outline-valence-primary-500 rounded-xl border-2 body-bold text-gray-600 border-[#E8E8E8] bg-white;
}
</style>
